// Module
var code = "<div class=\"sps-input min-w-[100px] max-w-[160px]\"> <input type=\"text\" class=\"\" data-bind=\"textInput: Value,\r\n                      attr: { title: Value }\"> </div>";
// Exports
export default code;